import { el } from 'redom';

import application from 'application';
import serverInterface from 'server-interface';

import { stringToSVG } from 'utilities';

import Tooltip from 'generics/components/tooltip/native';

import {
  determineAutoReply
} from './utilities';

import askAIIconString from 'assets/images/ask-ai-medium-icon.svg?raw';

import './index.scss';

const askAIIcon = stringToSVG(askAIIconString);

const levels = [
  'NO_AI',
  'AI_DRAFT',
  'AI_REPLY'
];

const tooltipContents = {
  [levels[0]]: 'Enable AI Suggestions',
  [levels[1]]: 'Enable AI Replies',
  [levels[2]]: 'Disable AI'
};

class AILevelButton {

  constructor(configuration) {

    this.conversation = configuration.conversation;
    this.internetPhone = configuration.internetPhone;

    const autoReply = determineAutoReply(this.conversation, application.getCurrentStartup().autoReplySettings);

    this.el = el('button.ai-level-button', {
      class: this.conversation.autoReply.toLowerCase(),
      onclick: this.handleClick.bind(this)
    }, [
      askAIIcon.cloneNode(true)
    ]);

    this.tooltip = new Tooltip({
      target: this.el,
      content: tooltipContents[autoReply],
      placement: 'top',
      offset: 10,
      placeOnCenter: true
    });

  }

  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();

    if (!this.conversation) {
      return;
    }
    const currentLevel = determineAutoReply(this.conversation, application.getCurrentStartup().autoReplySettings);
    const currentIndex = levels.indexOf(currentLevel);
    const nextLevel = levels[(currentIndex + 1) % levels.length];
    this.conversation.autoReply = nextLevel;
    this.update({
      conversation: {
        ...this.conversation,
        updatedAt: Date.now()
      },
      internetPhone: this.internetPhone
    });

    if (this.conversation.autoReply === levels[1]) {
      this.internetPhone.showSuggestions();
    } else {
      this.internetPhone.hideSuggestions();
    }

    serverInterface.startup.helpdesk.setConversationAutoReply(this.conversation._id, { autoReply: nextLevel });
  }

  update(configuration) {

    if (this.conversation.updatedAt > configuration.conversation.updatedAt) {
      return;
    }

    this.conversation = configuration.conversation;
    this.internetPhone = configuration.internetPhone;

    const autoReply = determineAutoReply(this.conversation, application.getCurrentStartup().autoReplySettings);

    for (let level of levels) {
      this.el.classList.remove(level.toLowerCase());
    }
    const level = autoReply;

    this.el.classList.add(level.toLowerCase());
    this.tooltip.update({
      content: tooltipContents[level]
    });
  }
}

export default AILevelButton;